import { Component, AfterViewInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { MdColorPicker } from 'md-color-picker';
import { v4 as uuid } from 'uuid';
import { tap, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { fromEvent } from 'rxjs/observable/fromEvent';

@Component({
  template: `
  <div class="color-picker-wrapper">
    <div class="color-picker" id="{{id}}" [ngClass]="{'noButton': hide}"></div>
  </div>
  `,
  styles: [
    `
    .color-picker-wrapper{
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .color-picker-value{
      display:flex;
    }
    .color-picker{
      display:flex;
    }
  `
  ],
  selector: 'color-picker'
})
export class ColorPickerComponent implements AfterViewInit, OnDestroy {
  @Input() value: string;
  @Input() hide: boolean;
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();
  id = uuid();
  componentDestroyed$ = new Subject();

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

  ngAfterViewInit() {
    const ee = MdColorPicker({
      elementName: this.id,
      createIcon: true,
      defaultColor: `#${this.value}`
    });
    const color$ = fromEvent(ee, 'color-changed');
    const updateValue$ = tap((color: any) => {
      this.value = color;
      this.valueChange.emit(color);
    });

    color$.pipe(takeUntil(this.componentDestroyed$), updateValue$).subscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/colorPicker/color-picker.component.ts